import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["notification"]

  connect() {
    this.grouped = false
    this.group()
    this.grouped = true
  }

  notificationTargetConnected(notification) {
    if (this.grouped) {
      this.#groupSingle(notification)
    }
  }

  group() {
    const byKey = this.#groupByKey()

    for (const key in byKey) {
      const items = byKey[key]
      if (items.length > 1) {
        this.#renderGroup(items)
      }
    }
  }

  #groupByKey() {
    return this.notificationTargets.reduce((acc, el) => {
      const key = `${el.dataset.itemType}-${el.dataset.itemId}`
      if (!key || key === "undefined-undefined") return acc
      acc[key] = acc[key] || []
      acc[key].push(el)
      return acc
    }, {})
  }

  #groupSingle(notification) {
    const key = `${notification.dataset.itemType}-${notification.dataset.itemId}`
    if (!key || key === "undefined-undefined") return

    const existing = this.notificationTargets.filter(el =>
      `${el.dataset.itemType}-${el.dataset.itemId}` === key && el !== notification
    )

    if (existing.length > 0) {
      this.#renderGroup([...existing, notification])
    }
  }

  #renderGroup(items) {
    items.sort((a, b) =>
      parseInt(a.dataset.timestamp) - parseInt(b.dataset.timestamp)
    )

    const first = items[0]
    const countEl = first.querySelector("[data-group-count]")
    if (countEl) countEl.textContent = items.length

    first.classList.add("grouped")

    items.slice(1).forEach(el => {
      el.style.display = "none"
    })
  }
}
